<template>
	<div
		:class="[
			`shared-state-icon shared-state-icon--${state}`,
			{ 'shared-state-icon--small': small },
			{ 'shared-state-icon--clickable': clickable },
		]">
		<svg
			v-if="state === 'complete' && !small"
			viewBox="0 0 12 10">
			<polyline points="1.5 6 4.5 9 10.5 1"/>
		</svg>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedStateIconEmits, SharedStateIconProps } from './SharedStateIconSetup';
import SharedStateIconSetup from './SharedStateIconSetup';
const emits = defineEmits<SharedStateIconEmits>() as SharedStateIconEmits;
const props = withDefaults(defineProps<SharedStateIconProps>(), SharedStateIconSetup.defaultProps);
const setup = new SharedStateIconSetup(props, emits);
// #endregion
</script>

<style lang="less">
@import "@/styles/mixins";

.shared-state-icon {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.6rem;
	color: white;
	background-color: white;
	transition: all 0.3s;
	.circle(1rem);

	&--small {
		.circle(0.5rem);
	}

	&--complete {
		background-color: var(--success);
	}

	&--empty {
		background: rgba(var(--rgb-grey-light), 1);
	}

	&--danger {
		background: rgba(var(--rgb-danger-alt), 1);
	}

	&--partial {
		border: solid 0.1rem var(--info);
	}

	&--warning {
		background: rgba(var(--rgb-warning-alt), 1);
	}

	&--clickable {
		cursor: pointer;

		&::before {
			content: "";
			position: absolute;
			z-index: -1;
			width: calc(100% + 1rem);
			height: calc(100% + 1rem);
			border: 1px solid var(--grey-light);
			border-radius: 50%;
			transition: all 0.3s;
		}

		&:hover {
			&::before {
				border-color: var(--info);
				background: rgba(var(--rgb-info), 0.1);
			}
		}
	}

	svg {
		width: 0.75rem;
		height: 0.5rem;
		fill: none;
		stroke: white;
		stroke-dasharray: 1rem;
		stroke-linecap: round;
		stroke-linejoin: round;
		stroke-width: 2;
	}
}

</style>
